var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[_c('v-card',{attrs:{"flat":"","tile":""}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',[_c('v-flex',{attrs:{"justify-center":"","text-xs-left":""}},[_c('v-card-text',[_c('div',{staticClass:"mx-auto"})])],1)],1)],1)],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68060628","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Splash.vue
// module id = null
// module chunks = 